var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartProjectModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start-project"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 0C31.05 0 40 8.95 40 20C40 31.05 31.05 40 20 40C8.95 40 0 31.05 0 20C0 8.95 8.95 0 20 0Z",
    fill: "#E7D6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3125 22.625L17.0375 19.8875L20.025 22.875L17.2875 28.575L7.58752 32.5L11.3125 22.625Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.9 11.925L19.975 12.0125L24.5 7.5L32.1875 7.7375L32.4 15.4125L27.8875 19.9375L27.975 23.0125L21.5625 29.425L20.8875 24.1875L15.725 19.025L10.475 18.4125L16.8875 11.9375L16.9 11.925ZM24.2 15.6875L27.375 16.7125L29.55 14.55L29.6375 10.2625L25.35 10.35L23.2 12.5L24.2 15.6875Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.8625 22.5375L26.775 19.475C26.775 19.475 26.775 19.475 26.775 19.4625L31.2625 14.975C31.2625 14.975 31.2625 14.975 31.2625 14.9625L31.1375 10.65L31.0875 8.86251V8.82501C31.0875 8.82501 31.0875 8.80001 31.0625 8.80001L29.25 8.75001L24.95 8.63751C24.95 8.63751 24.95 8.63751 24.9375 8.63751L20.45 13.125C20.45 13.125 20.45 13.125 20.4375 13.125L17.375 13.0375C17.375 13.0375 17.375 13.0375 17.3625 13.0375L12.9 17.5V17.5375L16.25 17.925L21.9375 23.625L22.325 26.9875C22.325 27 22.35 27.0125 22.3625 26.9875L26.825 22.525C26.825 22.525 26.825 22.525 26.825 22.5125L26.8625 22.5375ZM27.4125 16.7C27.4125 16.7 27.4 16.7 27.3875 16.7L25.6375 16.1375L24.675 15.825L24.2375 15.6875H24.225L23.7875 14.275V14.2375L23.225 12.5125C23.225 12.5125 23.225 12.5 23.225 12.4875L25.375 10.3375C25.375 10.3375 25.375 10.3375 25.3875 10.3375L27.6 10.4125H27.65L29.4 10.475C29.4 10.475 29.4125 10.475 29.425 10.475L29.4875 12.2375C29.4875 12.2375 29.4875 12.2375 29.4875 12.25L29.5625 14.4875C29.5625 14.4875 29.5625 14.4875 29.5625 14.5L27.4125 16.65V16.7Z",
    fill: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.825 12.2375C26.5875 12.475 26.2 12.475 25.975 12.2375C25.9375 12.2 25.9 12.1625 25.875 12.1125C25.75 11.8875 25.775 11.5875 25.975 11.3875C26.175 11.1875 26.475 11.15 26.7 11.275C26.75 11.3 26.7875 11.325 26.825 11.375C27.0625 11.6125 27.05 11.9875 26.8125 12.2375H26.825Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.5 13.9125C28.3 14.1125 28 14.15 27.775 14.025C27.725 14 27.6875 13.975 27.65 13.925C27.4125 13.6875 27.425 13.3125 27.65 13.075C27.875 12.8375 28.275 12.825 28.5 13.0625C28.5375 13.1 28.575 13.1375 28.6 13.1875C28.725 13.4125 28.6875 13.7125 28.4875 13.9125H28.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.475 27.7L9.55005 30.5L9.62505 30.2875L12.2125 23.4375C12.2125 23.4375 16.8 21.225 16.8125 21.2375L18.6875 23.1125L16.4875 27.7125L16.475 27.7Z",
    fill: "#ED8936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.475 27.7L9.55005 30.5L9.62505 30.2875L12.2125 23.4375C12.2125 23.4375 16.8 21.225 16.8125 21.2375L18.6875 23.1125L16.4875 27.7125L16.475 27.7Z",
    fill: "#ED8936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M27.6625 13.9375C27.425 13.7 27.4375 13.325 27.6625 13.0875C27.8875 12.85 28.2875 12.8375 28.5125 13.075C28.7375 13.3125 28.7375 13.6875 28.5 13.925C28.2625 14.1625 27.8875 14.175 27.65 13.9375H27.6625Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M26.8499 22.55L22.3875 27.0125H22.3499L21.9625 23.6625L19.1375 20.825C19.1375 20.825 19.1375 20.8 19.1375 20.7875L24.2125 15.7125C24.2125 15.7125 24.2125 15.7125 24.2374 15.7125L24.675 15.85L25.6375 16.15L27.3875 16.7125C27.3875 16.7125 27.4 16.7125 27.4125 16.7125L29.5625 14.5625C29.5625 14.5625 29.5625 14.5625 29.5625 14.55L29.475 12.3L29.4125 10.5375C29.4125 10.5375 29.4125 10.5375 29.4125 10.525L31.05 8.88751C31.05 8.88751 31.0875 8.88751 31.0875 8.90001L31.1375 10.6875L31.2625 15C31.2625 15 31.2625 15 31.2625 15.0125L26.775 19.5C26.775 19.5 26.775 19.5 26.775 19.5125L26.8625 22.575C26.8625 22.575 26.8625 22.575 26.8625 22.5875L26.8499 22.55Z",
    fill: "#B794F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20.625 28.475H20.6V28.45C20.6 28.4625 20.6 28.475 20.625 28.475Z",
    fill: "#B794F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.2,
    d: "M31.1375 10.6625L29.5125 12.2875C29.5125 12.2875 29.475 12.2875 29.475 12.275L29.4125 10.5125C29.4125 10.5125 29.4125 10.4875 29.3875 10.4875L27.625 10.425C27.625 10.425 27.6 10.4 27.6125 10.3875L29.2375 8.76251C29.2375 8.76251 29.2375 8.76251 29.25 8.76251L31.0625 8.81251C31.0625 8.81251 31.0875 8.81251 31.0875 8.83751L31.1375 10.6625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.2,
    d: "M23.725 14.2875H23.7625L24.2 15.6875H24.2125L24.65 15.8375L25.6125 16.1375V16.175L20.0625 21.725C20.0625 21.725 20.0375 21.725 20.025 21.725L18.15 19.85C18.15 19.85 18.15 19.825 18.15 19.8125L23.7 14.2625L23.725 14.2875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M18.675 23.1L16.475 27.7L9.55005 30.5L9.62505 30.2875L17.7375 22.175L18.675 23.1125V23.1Z",
    fill: "#F6AD55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M8.76245 31.3L11.85 23.1125L16.9 20.7L19.2125 23.0125L16.8 28.05L8.76245 31.3ZM12.5625 23.7625L10.325 29.7L16.1375 27.35L18.125 23.2L16.7 21.775L12.55 23.7625H12.5625Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.9375 17.9L17.175 12.6125L20.25 12.7L24.775 8.1875L31.5375 8.4L31.725 15.15L27.225 19.675L27.3125 22.75L22.075 27.9875L21.55 23.875L16.0625 18.3875L11.95 17.9125L11.9375 17.9ZM17.5375 13.5125L13.8625 17.225L16.45 17.525L22.375 23.45L22.7125 26.0625L26.3875 22.3875L26.3 19.3125L30.8 14.7875L30.65 9.2625L25.1125 9.0875L20.5875 13.5875L17.5125 13.5L17.5375 13.5125Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M23.8375 16.05L22.6875 12.3875L25.1875 9.90002L29.8125 10.075L30.0125 14.725L27.5125 17.225L23.825 16.0625L23.8375 16.05ZM23.7125 12.6375L24.5625 15.3375L27.2875 16.2L29.125 14.3625L28.975 10.925L25.5625 10.8L23.725 12.6375H23.7125Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M20.6 28.45V28.475C20.6 28.475 20.6125 28.475 20.625 28.475C20.625 28.475 20.6 28.475 20.6 28.45Z",
    fill: "#171923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M20.6 28.45V28.475C20.6 28.475 20.6125 28.475 20.625 28.475C20.625 28.475 20.6 28.475 20.6 28.45Z",
    fill: "#171923"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartProjectModal);
export default __webpack_public_path__ + "static/media/StartProjectModal.1bd70fbd2917cdc2ee60e0c4d960b641.svg";
export { ForwardRef as ReactComponent };